import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { EConfig } from '../../modules/common/lib/model/common';
import { AuthService, StorageService } from '../../modules/common/service';
import { UserControlService } from '../../modules/common/service/userControl/user-control.service';

@Component({
    selector: 'app-maintenance',
    templateUrl: './app.maintenance.html',
    standalone: false
})

export class AppMaintenanceComponent {
    constructor(private userControlService: UserControlService, private authService: AuthService, private router: Router, private storageService: StorageService) {
        /* For redirecting to home page if the API starts giving response as it is the first API which gets called , Without it no data will be visible */
        this.userControlService.getAirUserConfig().then((details: any) => {
            if (details) {
                // this.userControlService.updateUserSettings(details);
                // this.authService.updateEula(true, details.companies);
                if (this.storageService.getItem('errorCount') == 1) {
                    this.authService.loginRedirect();
                }
            }

        });


    }
}
